import { forwardRef, type Ref, type SVGProps } from "react";
function SvgDocumentIdOutlined(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.25 9.75h-4.5m2.52 3h-2.52m5.5 6.5H5.75a3 3 0 0 1-3-3v-8.5a3 3 0 0 1 3-3h12.5a3 3 0 0 1 3 3v8.5a3 3 0 0 1-3 3m-10-6h-.5a1 1 0 0 1-1-1v-1.5a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentIdOutlined);
export default ForwardRef;
